import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const vaultService = createApi({
  reducerPath: "vaultService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getVaultService: builder.query<any, any>({
      query: (params) => ({
        url: `/vault-service`,
        params,
        method: "GET",
        headers: {
          PageName: "Vault Service",
        },
      }),
    }),
    getVaultServiceDetail: builder.query<any, { token: string }>({
      query: ({token}) => ({
        url: `/vault-service/${token}`,
        method: "GET",
        headers: {
          PageName: "Vault Service",
        },
      }),
    }),
    getVaultIntegrationList: builder.query<any, any>({
      query: (params) => ({
        url: `/vault-service/integration`,
        params,
        method: "GET",
        headers: {
          PageName: "Vault Integration",
        },
      }),
    }),
    getVaultIntegrationDetail: builder.query<any, { partnerId: number, id: number }>({
      query: ({partnerId, id}) => ({
        url: `/vault-service/integration/${partnerId}/${id}`,
        method: "GET",
        headers: {
          PageName: "Vault Integration",
        },
      }),
    }),
    getVaultTokenDetail: builder.query<any, { token: string }>({
      query: ({token}) => ({
        url: `/vault-service/secureFieldsInfo/${token}`,
        method: "GET",
        headers: {
          PageName: "Vault Service",
        },
      }),
    }),
    showVaultTokenDetail: builder.query<any, any>({
      query: (params) => ({
        url: `/vault-service/showSecureFields`,
        params,
        method: "GET",
        headers: {
          PageName: "Vault Service",
        },
      }),
    }),
    getLogsVaultServices: builder.query<any, { token: string }>({
      query: (params) => ({
        url: `/vault-service/${params?.token}/logs`,
        method: "GET",
        headers: {
          PageName: "Vault Service",
        },
      }),
    }),
  }),
});

export const {
  useLazyGetVaultServiceQuery,
  useLazyGetVaultServiceDetailQuery,
  useLazyGetVaultTokenDetailQuery,
  useLazyShowVaultTokenDetailQuery,
  useLazyGetVaultIntegrationListQuery,
  useLazyGetVaultIntegrationDetailQuery,
  useLazyGetLogsVaultServicesQuery,
} = vaultService;
